import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

let state = {
    name:"",
    address:"",
    licence:"",
    tel:"",
    userid:"",
    password:""

}

// Actions(行动): 处理交互行为
const actions = {
    // context: 简化版的 store；    value: 发送过来的数据
    changeDispatch(context, value) {
   
        // 将数据 commit 给 mutations
        // 设置 2 个实参: commit 中的方法名 & 发送的数据
        context.commit("changeCommit", value);
    },
};


// Mutations(变化): 修改 state 中的数据
const mutations = {
    // state: 存储的数据；    value: 发送的数据
    changeCommit(state, value) {
       
        // 修改 state 中存储的数据
        state.name = value.name,
        state.address = value.address,
        state.licence = value.licence,
        state.tel = value.tel,
        state.image = value.image,
        state.userid = value.userid, //企业端的登录账号
        state.password = value.password //企业端的登录密码 
        // 修改后，页面会重新渲染
    },
};



export default  new Vuex.Store({
    state,
    actions,
    mutations,
})
    
